// extracted by mini-css-extract-plugin
export default {"timer":"timer_timer__2sc2+","actionButton":"timer_actionButton__Aht27","display":"timer_display__bG-4S"};